/* KBW Style Browser — the filter rail.

   The wall itself is printed by Liquid. This only builds the rail and hides
   cards, which is why the page works with scripting off: a <noscript> block
   drops the rail and the whole wall stays.

   Filter options are read off the cards rather than declared anywhere, so a
   filter can never offer a value that would return nothing, and new styles
   appear in the rail the moment they are mapped.

   Filter state is deliberately kept out of the URL. Filtered views of the same
   wall are how a site grows hundreds of near-identical pages; there is one page
   here and it is the one that gets indexed.

   Markup contract:
     [data-kbw-styles]         section root
     [data-kbw-styles-rail]    the rail
     [data-kbw-styles-groups]  where groups are written
     [data-kbw-styles-grid]    the wall
     [data-kbw-styles-count]   "N styles"
     [data-kbw-styles-empty]   shown when nothing matches
     [data-kbw-styles-reset]   clears every choice
     .kbw-styles-card[data-*]  one card per style
*/

(function () {
  'use strict';

  /* Attribute → label. Order here is the order in the rail. */
  /* Same running order as the product screens: the widest cut first, then the
     kind of thing, then everything else. Brand and Category never appear on
     the same wall -- a category carries no brand -- so between them this is
     just "whichever of the two this wall has, first". */
  var GROUPS = [
    ['brand', 'Brand'],
    ['category', 'Category'],
    ['color', 'Color'],
    ['door', 'Door style'],
    ['finish', 'Finish'],
    ['construction', 'Construction'],
    ['styletype', 'Style'],
  ];

  function setup(root) {
    if (root.dataset.kbwStylesReady === '1') return;

    var grid = root.querySelector('[data-kbw-styles-grid]');
    var rail = root.querySelector('[data-kbw-styles-rail]');
    var holder = root.querySelector('[data-kbw-styles-groups]');
    var countEl = root.querySelector('[data-kbw-styles-count]');
    var emptyEl = root.querySelector('[data-kbw-styles-empty]');
    var resetEl = root.querySelector('[data-kbw-styles-reset]');
    if (!grid || !holder) return;

    var cards = [].slice.call(grid.querySelectorAll('.kbw-styles-card'));
    if (!cards.length) return;

    root.dataset.kbwStylesReady = '1';

    var noun = (countEl && countEl.textContent.replace(/^\s*\d+\s*/, '').trim()) || 'styles';
    var chosen = {};

    /* Values actually present, with how many carry each. A group with fewer
       than two values would be a filter that cannot narrow anything, so it is
       not drawn at all. */
    function collect(attr) {
      var counts = {};
      cards.forEach(function (c) {
        var v = c.getAttribute('data-' + attr);
        if (v) counts[v] = (counts[v] || 0) + 1;
      });
      return counts;
    }

    GROUPS.forEach(function (pair) {
      var attr = pair[0];
      var counts = collect(attr);
      var values = Object.keys(counts).sort();
      if (values.length < 2) return;

      var box = document.createElement('div');
      box.className = 'kbw-styles__group';

      var title = document.createElement('p');
      title.className = 'kbw-styles__group-title';
      title.textContent = pair[1];
      box.appendChild(title);

      values.forEach(function (v) {
        var label = document.createElement('label');
        label.className = 'kbw-styles__opt';

        var input = document.createElement('input');
        input.type = 'checkbox';
        input.value = v;
        input.addEventListener('change', function () {
          var set = chosen[attr] || (chosen[attr] = []);
          var i = set.indexOf(v);
          if (input.checked && i < 0) set.push(v);
          if (!input.checked && i >= 0) set.splice(i, 1);
          apply();
        });

        var text = document.createElement('span');
        text.textContent = v;

        var num = document.createElement('span');
        num.className = 'kbw-styles__opt-count';
        num.textContent = counts[v];

        label.appendChild(input);
        label.appendChild(text);
        label.appendChild(num);
        box.appendChild(label);
      });

      holder.appendChild(box);
    });

    /* No group was worth drawing — every style shares the same values. The
       rail stays hidden rather than standing there empty. */
    if (!holder.children.length) return;
    if (rail) rail.classList.add('is-ready');

    /* The second column is opened here rather than in the stylesheet: only
       this line knows the rail ended up with something in it. */
    var layoutEl = root.querySelector('.kbw-styles__layout');
    if (rail && layoutEl) layoutEl.classList.add('is-railed');

    /* --- The drawer -------------------------------------------------------
       Below 1024px the rail is a panel over the page. Only the button that
       opens it is new; the rail itself is the same element the desktop layout
       uses, so nothing is duplicated and nothing has to be kept in step. */

    var openEl = root.querySelector('[data-kbw-styles-open]');
    var closeEl = root.querySelector('[data-kbw-styles-close]');
    var scrimEl = root.querySelector('[data-kbw-styles-scrim]');
    var applyEl = root.querySelector('[data-kbw-styles-apply]');
    var badgeEl = root.querySelector('[data-kbw-styles-badge]');
    var applyCountEl = root.querySelector('[data-kbw-styles-applycount]');

    if (openEl) openEl.hidden = false;

    var wide = window.matchMedia('(min-width: 1024px)');
    var scrollWas = '';

    function openDrawer() {
      if (!rail || wide.matches) return;
      rail.classList.add('is-open');
      if (scrimEl) scrimEl.hidden = false;
      if (openEl) openEl.setAttribute('aria-expanded', 'true');
      scrollWas = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      if (closeEl) closeEl.focus();
    }

    function closeDrawer() {
      if (!rail || !rail.classList.contains('is-open')) return;
      rail.classList.remove('is-open');
      if (scrimEl) scrimEl.hidden = true;
      if (openEl) {
        openEl.setAttribute('aria-expanded', 'false');
        openEl.focus();
      }
      document.body.style.overflow = scrollWas;
    }

    if (openEl) openEl.addEventListener('click', openDrawer);
    if (closeEl) closeEl.addEventListener('click', closeDrawer);
    if (scrimEl) scrimEl.addEventListener('click', closeDrawer);
    if (applyEl) applyEl.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    /* Rotating the phone to landscape can cross into the desktop layout with
       the drawer still open — which would leave the page unable to scroll. */
    var onWide = function (e) {
      if (e.matches) {
        rail.classList.remove('is-open');
        if (scrimEl) scrimEl.hidden = true;
        document.body.style.overflow = scrollWas;
      }
    };
    if (wide.addEventListener) wide.addEventListener('change', onWide);
    else if (wide.addListener) wide.addListener(onWide);

    function matches(card) {
      for (var attr in chosen) {
        var want = chosen[attr];
        if (!want.length) continue;
        if (want.indexOf(card.getAttribute('data-' + attr)) < 0) return false;
      }
      return true;
    }

    function apply() {
      var visible = 0;
      cards.forEach(function (c) {
        var ok = matches(c);
        c.hidden = !ok;
        if (ok) visible++;
      });

      if (countEl) countEl.textContent = visible + ' ' + noun;
      if (emptyEl) emptyEl.hidden = visible > 0;
      if (applyCountEl) applyCountEl.textContent = visible;

      /* How many boxes are ticked, not how many groups have something ticked —
         the badge answers "how much have I narrowed this", and with the drawer
         shut that number is the only trace of it left on screen. */
      var picked = 0;
      Object.keys(chosen).forEach(function (k) { picked += chosen[k].length; });
      if (badgeEl) {
        badgeEl.hidden = picked === 0;
        badgeEl.textContent = picked;
      }
      if (resetEl) resetEl.hidden = picked === 0;
    }

    if (resetEl) {
      resetEl.addEventListener('click', function () {
        chosen = {};
        holder.querySelectorAll('input[type="checkbox"]').forEach(function (i) { i.checked = false; });
        apply();
      });
    }

    apply();
  }

  function setupAll() {
    var roots = document.querySelectorAll('[data-kbw-styles]');
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAll);
  } else {
    setupAll();
  }

  // The theme editor re-renders a section in place.
  document.addEventListener('shopify:section:load', setupAll);
})();

/* Series card pictures.
 *
 * A card that leads to five finishes shows all five. It does not play on its
 * own -- a dozen cards cycling is a page that will not sit still -- but under
 * the pointer it advances on a timer, and the dots let the visitor go straight
 * to one.
 *
 * The dots answer to hover rather than click: the whole card is a link, and a
 * click anywhere on it should open the collection, not change a picture.
 *
 * One timer, and only while a pointer is actually on a card.
 */
(function () {
  var ARALIK = 1500;

  function kur(slider) {
    if (slider.dataset.kbwCardReady) return;
    slider.dataset.kbwCardReady = '1';

    var kareler = slider.querySelectorAll('[data-kbw-card-frame]');
    var noktalar = slider.querySelectorAll('[data-kbw-card-dot]');
    if (kareler.length < 2) return;

    var simdi = 0;
    var sayac = null;

    function goster(i) {
      simdi = (i + kareler.length) % kareler.length;
      for (var n = 0; n < kareler.length; n++) {
        kareler[n].classList.toggle('is-on', n === simdi);
        if (noktalar[n]) noktalar[n].classList.toggle('is-on', n === simdi);
      }
    }

    function basla() {
      if (sayac) return;
      sayac = setInterval(function () {
        goster(simdi + 1);
      }, ARALIK);
    }

    function dur(basaDon) {
      clearInterval(sayac);
      sayac = null;
      if (basaDon) goster(0);
    }

    slider.addEventListener('pointerenter', basla);
    slider.addEventListener('pointerleave', function () {
      dur(true);
    });

    for (var d = 0; d < noktalar.length; d++) {
      (function (i) {
        noktalar[i].addEventListener('pointerenter', function () {
          // A deliberate choice beats the timer; it picks up again from here.
          dur(false);
          goster(i);
          basla();
        });
      })(d);
    }

    // Someone who asked for less motion gets the dots and nothing automatic.
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      slider.removeEventListener('pointerenter', basla);
      dur(false);
    }
  }

  function kurHepsi() {
    var l = document.querySelectorAll('[data-kbw-card-slider]');
    for (var i = 0; i < l.length; i++) kur(l[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kurHepsi);
  } else {
    kurHepsi();
  }
  document.addEventListener('shopify:section:load', kurHepsi);
})();
